import React, { useState } from "react";
import { forwardRef, ReactNode } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Offcanvas } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import NavItem from "react-bootstrap/NavItem";
import NavLink from "react-bootstrap/NavLink";
import { Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { ReactComponent as ToggleButton } from "../../app/assets/icons/topnav/toggle-button.svg";
import { ReactComponent as WLCBrandingcon } from "../../app/assets/icons/topnav/wlc-branding.svg";
import { ReactComponent as WLCBrandingconBlack } from "../../app/assets/icons/topnav/wlc-branding-black.svg";
import { ReactComponent as SignoutTopnavIcon } from "../../app/assets/icons/topnav/signout.svg";
import { ReactComponent as TopnavMenuChevroletUpIcon } from "../../app/assets/icons/topnav/chevrolet-up.svg";
import { ReactComponent as TopnavMenuChevroletDownIcon } from "../../app/assets/icons/topnav/chevrolet-down.svg";
import { useAppSelector } from "../../redux/store";
import LeftNav from "../Leftnav/Leftnav";
import ProfileImage from "./ProfileImage";
import "./topnav.scss";

interface Props {
  children?: ReactNode;
  style?: React.CSSProperties;
  className: string;
  "aria-labelledby": string;
}
export type Ref = HTMLDivElement;

type TopnavMenuItemProps = {
  icon: any;
  label: string;
  to?: string;
  onClick?: () => void;
};

const Administrationtitle = () => {
  const currentEnv = process.env.REACT_APP_ENV ?? "dev";
  return (
    <div className="topnav-administation-title">
      Administration - {currentEnv}
    </div>
  );
};

const TopnavMenuItem = ({ icon, label, to, onClick }: TopnavMenuItemProps) => {
  const navigate = useNavigate();

  const handleClickNavitem = (to: string | undefined) => {
    if (!!to) {
      navigate(to);
    }
    if (onClick) onClick();
  };

  return (
    <>
      <Dropdown.Item onClick={() => handleClickNavitem(to)}>
        <>
          <div className="d-flex align-items-center gap-2">
            {icon}
            <div className="topnav-menuitem">{label}</div>
          </div>
        </>
      </Dropdown.Item>
    </>
  );
};

// forwardRef again here!
// Dropdown needs access to the DOM of the Menu to measure it
const CustomMenu2 = forwardRef<Ref, Props>(
  ({ style, className, "aria-labelledby": labeledBy }, ref) => {
    const auth = useAppSelector((state) => state.auth);

    // let badge = "ADMIN";

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
        data-bs-popper="static"
      >
        <div className="topnav-menu-username">
          {auth.firstName} {auth.lastName}
        </div>
        {/* <div className="topnav-menu-email">{auth.email}</div> */}

        <Badge bg="primary" className="topnav-menu-role-badge">
          ADMIN
        </Badge>

        <Dropdown.Divider />

        <TopnavMenuItem
          icon={<SignoutTopnavIcon />}
          label="Sign Out"
          to="/signout"
        />
      </div>
    );
  }
);

export default function TopNavbar() {
  const [showleftnav, setShowleftnav] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // const dispatch = useAppDispatch();

  // const location = useLocation();
  const auth = useAppSelector((state) => state.auth);

  // const navigate = useNavigate();

  const handleToggle = () => {
    setShowleftnav(!showleftnav);
  };

  const handleDropdownToggle = (isOpen: boolean) => {
    setDropdownOpen(isOpen);
  };

  return (
    <Navbar
      className="sticky-top justify-content-between"
      expand="lg"
      bg="primary"
      id="topnavmenu"
    >
      <>
        <div className="d-flex column-gap-2 align-items-center">
          <div className="bg-light toggle-button" onClick={handleToggle}>
            <ToggleButton />
          </div>
        </div>

        <Offcanvas
          show={showleftnav}
          onHide={handleToggle}
          className="offcanvas"
        >
          <Offcanvas.Header closeButton className="pb-2">
            <Offcanvas.Title>
              <WLCBrandingconBlack
                style={{
                  height: "40px",
                  width: "auto",
                  display: "block",
                  marginLeft: "10px",
                }}
              />
              {/* <Administrationtitle /> */}
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body className="pt-2 offcanvas-body">
            <LeftNav />
          </Offcanvas.Body>
        </Offcanvas>
      </>
      <div className="topanv-first-item">
        <WLCBrandingcon
          style={{
            height: "40px",
            width: "auto",
            display: "block",
            marginLeft: "10px",
          }}
        />
        <Administrationtitle />
      </div>

      <div className="topnav-last-item">
        <div>
          <Dropdown as={NavItem} onToggle={handleDropdownToggle}>
            <Dropdown.Toggle
              className={`me-2 rounded-pill text-white d-flex align-items-center ${dropdownOpen && "rounded-pill-open"}`}
              // style={mystylePillBackground}
              as={NavLink}
            >
              <ProfileImage
                src=""
                name={`${auth.firstName} ${auth.lastName}`}
                email={auth.email}
              />
              {dropdownOpen ? (
                <TopnavMenuChevroletUpIcon className="ms-2" />
              ) : (
                <TopnavMenuChevroletDownIcon className="ms-2" />
              )}
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="shadow-4 px-3 topnav-menu"
              align="end"
              as={CustomMenu2}
            >
              <Dropdown.Item eventKey="1">Red</Dropdown.Item>
              <Dropdown.Item eventKey="2">Blue</Dropdown.Item>
              <Dropdown.Item eventKey="3" active>
                Orange
              </Dropdown.Item>
              <Dropdown.Item eventKey="1">Red-Orange</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </Navbar>
  );
}
